module.exports = __webpack_public_path__ + "media/applicants/device_signup_8-au-4b94d7c8.jpg";